'use strict';
module.exports = [
  require('./clone'),
  require('./isInteger'),
  require('./isNegative'),
  require('./isNumeric'),
  require('./isPositive'),
  require('./isPrime'),
  require('./isZero'),
  require('./isNaN'),
  require('./typeof')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/utils/index.js
// module id = 1875
// module chunks = 0